import { darkTheme, defaultTheme } from '@adobe/react-spectrum';
export const customTheme = Object.assign(Object.assign({}, defaultTheme), { dark: darkTheme.light });
